/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form } from 'semantic-ui-react'

export default class CountdownField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props
    const options = [{ key: 1, text: 'No', value: false }, { key: 2, text: 'Yes', value: true }]

    return (
      <Form.Select
        fluid
        label="Countdown"
        options={options}
        placeholder="Countdown period time of deal"
        onChange={(e, data) => onChange(data.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/specialDeal/fields/countDownField.js